// The public demo ("portfolio") runs on Cloudflare Pages with synthetic data: the statistics come from
// the Pages Function at /api/stats and the breeding sites from public/demo/focos.geojson.
// "pontenova" is the tenant delivered to Gestão Engenharia, which served sites from PostGIS.
const environments: {
  [key: string]: {
    key: string;
    name: string;
    url: string;
    apiUrl: string;
  };
} = {
  portfolio: {
    key: "portfolio",
    name: "Ponte Nova",
    url: "https://libelula.territorial.dev",
    apiUrl: "/api",
  },
  pontenova: {
    key: "pontenova",
    name: "Ponte Nova",
    url: "https://pontenova.gestaoengenharia.dev",
    apiUrl: "https://api-libelula-pontenova.gestaoengenharia.dev",
  },
};

export default environments[process.env.REACT_APP_ENVIRONMENT || "portfolio"];
